export default __webpack_public_path__ + "static/media/category_communicate.57e6731b.svg";